import { render, staticRenderFns } from "./NewYearModal.vue?vue&type=template&id=3070218b&scoped=true&"
import script from "./NewYearModal.vue?vue&type=script&lang=js&"
export * from "./NewYearModal.vue?vue&type=script&lang=js&"
import style0 from "./NewYearModal.vue?vue&type=style&index=0&id=3070218b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070218b",
  null
  
)

export default component.exports